import { combineReducers } from '@reduxjs/toolkit';
import dbSummaryReducer from './dbSummary/dbSummaryTypeSlice'
import customerSatisfactionReducer from './getCustomerSatisfaction/customerSatisfactionSlice'
import homeServiceMonthlyListReducer from './getHomeServiceMonthlyList/homeServiceMonthlyListSlice'
import homeServiceSummaryReducer from './getHomeServiceSummary/homeServiceSummarySlice'
import packageMonthlyListReducer from './getPackageMonthlyList/packageMonthlyListSlice'
import packageSummaryReducer from './getPackageSummary/packageSummarySlice'
import productSummaryReducer from './getProductSummary/productSummarySlice'
import storeRoomStatusReducer from './getStoreRoomStatus/storeRoomStatusSlice'
import commandCenterOccupiedRoomsReducer from './commandCenterOccupiedRooms/commandCenterOccupiedRoomsSlice'
import commandCenterStaffAgentsPageReducer from './commandCenterStaffAgentsPage/commandCenterStaffAgentsPageSlice'
import serviceCompletionRateSummaryReducer from './getServiceCompletionRateSummary/serviceCompletionRateSummarySlice'
import storeListReducer from './storeList/storeSlice'
import staffListReducer from './staffList/StaffSlice'
import roomTypeReducer from './roomType/roomTypeSlice'

// 合并 dashboard 模块下的所有 reducer
const dashboardReducer = combineReducers({
  dbSummary: dbSummaryReducer,
  customerSatisfaction: customerSatisfactionReducer,
  homeServiceMonthlyList: homeServiceMonthlyListReducer,
  homeServiceSummary: homeServiceSummaryReducer,
  packageMonthlyList: packageMonthlyListReducer,
  packageSummary: packageSummaryReducer,
  productSummary: productSummaryReducer,
  storeRoomStatus: storeRoomStatusReducer,
  commandCenterOccupiedRooms: commandCenterOccupiedRoomsReducer,
  commandCenterStaffAgentsPage: commandCenterStaffAgentsPageReducer,
  serviceCompletionRateSummary: serviceCompletionRateSummaryReducer,
  storeList: storeListReducer,
  staffList: staffListReducer,
  roomType: roomTypeReducer
})

export default dashboardReducer